import React from 'react'
import Header from './component/header/Header'
import Nav from './component/nav/Nav'
import About from './component/about/About'
import Experience from './component/experience/Experience'
import Skills from './component/skills/Skills'
import Test from './component/test/Test'
import Contact from './component/contact/Contact'
const App = () => {
  return (
   <>
   <Header />
   <Nav />
   <About />
   <Experience />
   <Skills />
   <Test />
   <Contact />
   </>
  )
}

export default App